@if (queryProperty && queryProperties && queryProperties.length > 0) {
  <div style="width: 200px;">
    @if (queryProperty.type == queryPropertyType.Text || queryProperty.type == queryPropertyType.ReferenceCompany) {
      <custom-input [inputType]="inputTypeEnum.Text" [value]="value" (valueChange)="updateValue($event)" />
    }
    @if (queryProperty.type == queryPropertyType.Numeric) {
      <custom-input [inputType]="inputTypeEnum.Number" [value]="value" (valueChange)="updateValue($event)" />
    }
    @if (queryProperty.type == queryPropertyType.Date) {
      <date-input (valueChange)="updateValue($event)" />
    }
    @if (queryProperty.type == queryPropertyType.Select) {
      <custom-select
        [placeholder]="'query.select-placeholder' | translate"
        [selectList]="selectList"
        [value]="value"
        (valueChange)="updateValue($event)">
      </custom-select>
    }
    @if (queryProperty.customProperty == queryCustomType.TaskTemplateTag) {
      <custom-select
        [placeholder]="'query.task-template-tag-placeholder' | translate"
        [selectList]="taskTemplateTagList"
        [value]="value"
        (valueChange)="updateValue($event)">
      </custom-select>
    }
    @if (queryProperty.customProperty == queryCustomType.TaskflowTemplateTag) {
      <custom-select
        [placeholder]="'query.taskflow-template-tag-placeholder' | translate"
        [selectList]="taskflowTemplateTagList"
        [value]="value"
        (valueChange)="updateValue($event)">
      </custom-select>
    }
    @if (queryProperty.customProperty == queryCustomType.AssignedToUserTeam) {
      <custom-select
        [placeholder]="'query.assigned-user-placeholder' | translate"
        [selectList]="userTeamList"
        [value]="value"
        (valueChange)="updateValue($event)">
      </custom-select>
    }
    @if (queryProperty.type == queryPropertyType.ReferenceUsers) {
      <custom-select
        [placeholder]="'query.reference-users-placeholder' | translate"
        [selectList]="usersList"
        [value]="value"
        (valueChange)="updateValue($event)">
      </custom-select>
    }
    @if (queryProperty.customProperty == queryCustomType.TaskActionOnActiveStep) {
      <custom-select
        [placeholder]="'query.task-action-on-active-step-placeholder' | translate"
        [selectList]="selectList"
        [value]="value"
        (valueChange)="updateValue($event)">
      </custom-select>
    }
  </div>
}